import  { useState } from "react";
import Navbar from "../DashboardNavbar";
import CustomDrawer from "../CustomDrawer";
import Sidebar from "../Sidebar";
import BoxGroup from "../BoxGroup";

const Layout = ({ children }) => {
  
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  
  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    
  };

  return (
    <>
      <div className="layout">
        <div className="container-fluid m-0 g-0 p-0">
          <div className="navbarStyle">
            <Navbar
              isDrawerOpen={isDrawerOpen}
              handleDrawerToggle={handleDrawerToggle}
            />
          </div>
         

          <div>
            <BoxGroup isDrawerOpen={isDrawerOpen} handleDrawerToggle={handleDrawerToggle} />

          </div>

          <div className="otherPage">
            <div>
              <Sidebar />
            </div>
            <div
              className="pages"
              style={{
                paddingRight: isDrawerOpen ? "300px" : "0px",
                transition: "padding-right 0.3s ease-in-out",
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>

      
      <CustomDrawer
        isDrawerOpen={isDrawerOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
    </>
  );
};

export default Layout;
